import '@happylife-a/polyfill';

import React from 'react';
import webCore from '@happylife-a/web-core';
import webApp from '@happylife-a/web-app';
import appBranding from '@happylife-a/branding';
import ReactDOM from 'react-dom/client';
import App from './App';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

webCore.auth.helpers.setAuthStorageKeyPrefix('customer');

ReactDOM.createRoot(document.getElementById('root')).render(
  <webApp.providers.BrandingProvider appType="WebApp">
    <App RouterComponent={webApp.router.BrowserRouter} />
  </webApp.providers.BrandingProvider>
);
